import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import {Provider} from "react-redux"
import redux from "./store"
import { PersistGate } from 'redux-persist/integration/react'

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
)
root.render(
    <Provider store={redux.store}>
      <PersistGate loading={null} persistor={redux.persistor}>
        <React.StrictMode>
            <App/>
        </React.StrictMode>
      </PersistGate>
    </Provider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()
